// import React, { useState, useRef, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { BsPlusCircle } from "react-icons/bs";
// import ModalMember from '../modal/modal-member';
// import '../../assets/styles/member-picker.css';
// import{ROLES}from '../../cmps/../services/user.service'

// export function MemberPicker({ customHeight, info, responsables, onUpdate, userRol }) {
//     const members = useSelector(storeState => storeState.userModule.users);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedMembers, setSelectedMembers] = useState([]);
//     const elMemberSection = useRef(null);

//     const taskId = info.id_actividad;
//     const idField = info.idField;
//     const campo = info.campo;
//     // const isEditable = [1, 2, 7, 20].includes(userId) || campo !== "task-preview"; // Determinar si es editable

//     const isEditable = (userRol === ROLES.ADMIN || info.campo === "subtask-preview") && userRol !== ROLES.AUDITOR;


//     useEffect(() => {
//         // Filtra los responsables al cargar el componente
//         const initialSelectedMembers = members.filter(member =>
//             member.responsable.some(responsable => responsable[idField] === taskId)
//         );

//         setSelectedMembers(initialSelectedMembers);
//     }, [members, taskId, idField]);

//     function getMember(memberId) {
//         return members.find(member => member.id_usuario === memberId);
//     }

//     function onToggleMenuModal() {
//         setIsModalOpen(!isModalOpen); // Permitir abrir el modal para todos los usuarios
//     }

//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (elMemberSection.current && !elMemberSection.current.contains(event.target)) {
//                 setIsModalOpen(false);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);



//     function handleSelectMember(memberId) {
//         if (!isEditable) return; // Bloquear la acción si no es editable

//         // Actualiza el estado local con el nuevo miembro seleccionado
//         const newSelectedMember = getMember(memberId);

//         const memberAlreadyExists = selectedMembers.some(member => member.id_usuario === newSelectedMember.id_usuario);

//         if (!memberAlreadyExists) {
//             setSelectedMembers(prevSelectedMembers => [...prevSelectedMembers, newSelectedMember]);
//             onUpdate(taskId, idField, memberId, "ADD");

//         } else {
//             const newMembers = selectedMembers.filter(member => member.id_usuario !== newSelectedMember.id_usuario);
//             setSelectedMembers(newMembers);
//             onUpdate(taskId, idField, memberId, "REMOVE");
//         }
//     }

//     return (
//         <section
//             className="task-person"
//             ref={elMemberSection}
//             style={{ height: customHeight, cursor: isEditable ? 'pointer' : 'default' }} // Cambiar cursor según si es editable
//         >
//             <div
//                 className="members-imgs"
//                 style={{ width: "138px" }} // Sin opacidad
//                 onClick={onToggleMenuModal}
//             >
//                 {selectedMembers.length === 0 && <BsPlusCircle className="icon-person" />}
//                 {selectedMembers.map((member, index) => {
//                     if (index < 2) {
//                         return (
//                             <img
//                                 key={index}
//                                 className='member-img'
//                                 src={member.imgurl}
//                                 alt="member"
//                             />
//                         );
//                     } else {
//                         return null;
//                     }
//                 })}
//                 {selectedMembers.length > 2 && (
//                     <div className='show-more-membersss'>
//                         <span className='show-more-count'>+{selectedMembers.length - 2}</span>
//                     </div>
//                 )}
//             </div>
//             {isModalOpen &&
//                 <ModalMember
//                     taskMembers={selectedMembers}
//                     allMembers={members}
//                     onSelectMember={handleSelectMember}
//                     setIsModalOpen={setIsModalOpen}
//                     isEditable={isEditable} // Pasar el estado de edición al modal
//                 />}
//         </section>
//     );
// }



import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { BsPlusCircle } from "react-icons/bs";
import ModalMember from '../modal/modal-member';
import '../../assets/styles/member-picker.css';
import{ROLES}from '../../cmps/../services/user.service'
import { handleResponsable } from "../../store/user.actions";

export function MemberPicker({ customHeight, info, responsables, onUpdate, userRol }) {
    const members = useSelector(storeState => storeState.userModule.users);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const elMemberSection = useRef(null);
    const [RespToEdit, setRespToEdit] = useState([]);

    const taskId = info.id_actividad;
    const idField = info.idField;
    const campo = info.campo;
    // const isEditable = [1, 2, 7, 20].includes(userId) || campo !== "task-preview"; // Determinar si es editable

    
    const isEditable = (userRol === ROLES.ADMIN || info.campo === "subtask-preview") && userRol !== ROLES.AUDITOR;


    useEffect(() => {
        // Filtra los responsables al cargar el componente
        const initialSelectedMembers = members.filter(member =>
            member.responsable.some(responsable => responsable[idField] === taskId)
        );

        setSelectedMembers(initialSelectedMembers);
    }, [members, taskId, idField]);

    function getMember(memberId) {
        return members.find(member => member.id_usuario === memberId);
    }

    function onToggleMenuModal() {
        setIsModalOpen(!isModalOpen); // Permitir abrir el modal para todos los usuarios
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (elMemberSection.current && !elMemberSection.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    //Funcion para guardar o eliminar responsables de las actividades o sub actividades 
    function GuardarResponsable(Idtask, idField, IdResponsable, mode){
        const newResponsable = {
            ...RespToEdit,
            [idField]: Idtask,
            fk_usuario_id: IdResponsable,
        };
        // setRestEdit(newResponsable);

        handleResponsable(newResponsable, mode);
        console.log("miembro actualizar ",newResponsable);
    }

    function handleSelectMember(memberId) {
        if (!isEditable) return; // Bloquear la acción si no es editable

        console.log();
        // Actualiza el estado local con el nuevo miembro seleccionado
        const newSelectedMember = getMember(memberId);

        const memberAlreadyExists = selectedMembers.some(member => member.id_usuario === newSelectedMember.id_usuario);

        if (!memberAlreadyExists) {
            setSelectedMembers(prevSelectedMembers => [...prevSelectedMembers, newSelectedMember]);
            onUpdate(taskId, idField, memberId, "ADD");
          


        } else {
            const newMembers = selectedMembers.filter(member => member.id_usuario !== newSelectedMember.id_usuario);
           
            setSelectedMembers(newMembers);
            onUpdate(taskId, idField, memberId, "REMOVE");
        }
    }

    return (
        <section
            className="task-person"
            ref={elMemberSection}
            style={{ height: customHeight, cursor: isEditable ? 'pointer' : 'default' }} // Cambiar cursor según si es editable
        >
            <div
                className="members-imgs"
                style={{ width: "138px" }} // Sin opacidad
                onClick={onToggleMenuModal}
            >
                {selectedMembers.length === 0 && <BsPlusCircle className="icon-person" />}
                {selectedMembers.map((member, index) => {
                    if (index < 2) {
                        return (
                            <img
                                key={index}
                                className='member-img'
                                src={member.imgurl}
                                alt="member"
                            />
                        );
                    } else {
                        return null;
                    }
                })}
                {selectedMembers.length > 2 && (
                    <div className='show-more-membersss'>
                        <span className='show-more-count'>+{selectedMembers.length - 2}</span>
                    </div>
                )}
            </div>
            {isModalOpen &&
                <ModalMember
                    taskMembers={selectedMembers}
                    allMembers={members}
                    onSelectMember={handleSelectMember}
                    setIsModalOpen={setIsModalOpen}
                    isEditable={isEditable} // Pasar el estado de edición al modal
                />}
        </section>
    );
}